module.exports = __webpack_public_path__ + "media/src/images/testimonials/01-a79f8e6c0fe8dc9c3264f606d6e28d5f.jpg";